import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-player-reveal-layout-page',
  templateUrl: './player-reveal-layout-page.component.html',
  styleUrl: './player-reveal-layout-page.component.scss',
})
export class PlayerRevealLayoutPageComponent {
  private router = inject(Router);

  get isLeaderboard(): boolean {
    return this.router.isActive('/games/playerreveal/leaderboard', {
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
